module.exports = __webpack_public_path__ + "static/dean-ayesha-chairs.96ab25d7.jpg";